import React from "react";

export function useBuildData() {
  const [hash] = React.useState(process.env.REACT_APP_GIT_HASH);
  const [branch] = React.useState(process.env.REACT_APP_GIT_BRANCH);
  const [buildTime] = React.useState(process.env.REACT_APP_BUILD_TIME);
  const buildTimeAsDate = React.useMemo(() => {
    if (buildTime) {
      const parsedDate = new Date(Number(buildTime));
      if (parsedDate.toLocaleDateString() === "Invalid Date") return undefined;
      return parsedDate;
    }
    return undefined;
  }, [buildTime]);
  const buildData = React.useMemo(
    () => ({ hash, branch, buildTime: buildTimeAsDate }),
    [hash, branch, buildTimeAsDate],
  );
  return buildData;
}
